<template>
  <div
    class="card"
    :class="{ bordered, isWhite }"
  >
    <BasePicture
      class="card__image"
      :src="getLocalizedImagePath(`/images/cards/${card.image}`)"
    />

    <dl class="card__description">
      <dd
        class="typography__headline3"
        v-html="$t(card.title)"
      />

      <dt
        class="card__text typography__body1"
        v-html="$t(card.description)"
      />
    </dl>

    <BaseLink
      v-if="card.href"
      class="card__link card__text typography__body2"
      :href="card.href"
      @click="() => handleMoreDetailsClick(card.href)"
    >
      {{ $t("common.moreDetails") }}
    </BaseLink>
  </div>
</template>

<script setup lang="ts">
interface Card {
  description: string;
  href?: string;
  image: string;
  title: string;
}

interface Props {
  bordered?: boolean;
  card: Card;
  isWhite?: boolean;
}

defineProps<Props>();

const { sendEvent } = useAnalytics();
const { getLocalizedImagePath } = useLocalizedImage();

const handleMoreDetailsClick = (buttonLink: string) => {
  sendEvent("site_features_about_clicked", {
    button_link: buttonLink,
  });
};
</script>

<style scoped>
.card {
  display: grid;
  row-gap: 24px;
  height: 100%;
  padding: 32px 24px;
  border-radius: 32px;
}

.card.isWhite {
  background-color: #fff;
}

@media (--desktop) {
  .card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 40px;
    border-radius: 50px;
  }
}

.card.bordered {
  border: 1px solid var(--grey-5);
}

.card__image {
  width: 264px;
  height: 132px;
}

@media (--desktop) {
  .card__image {
    width: 280px;
    height: 140px;
  }
}

.card__description {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

.card__text {
  color: var(--grey-1-5);
}

.card__link {
  width: max-content;
  margin-top: auto;
  padding: 8px 24px;
  border-radius: 20px;
  background-color: var(--grey-6);
}
</style>
